const setCompanySignals = (payload) => ({
    type: 'SET_SIGNALS_LIST',
    payload,
});
const setCompanySharePrice = (payload) => ({
    type: 'SET_COMPANY_SHARE_PRICE',
    payload,
});
const setActiveRic = (payload) => ({
    type: 'SET_ACTIVE_RIC',
    payload,
});
const setActiveRicValue = (payload) => ({
    type: 'SET_ACTIVE_RIC_VALUE',
    payload,
});
const setFinancialData = (payload) => ({
    type: 'SET_FINANCIAL_DATA',
    payload,
});
const setCompanyList = (payload) => ({
    type: 'SET_COMPANY_LIST',
    payload,
});
const setCriticalFactors = (payload) => ({
    type: 'SET_CRITICAL_FACTORS',
    payload,
});
const setFilteredCriticalFactors = (payload) => ({
    type: 'SET_FILTERED_CRITICAL_FACTORS',
    payload,
});
const setStockConsensus = (payload) => ({
    type: 'SET_STOCK_CONSENSUS',
    payload,
});
const setShareRatio = (payload) => ({
    type: 'SET_SHARE_RATIO',
    payload,
});
const set360Data = (payload) => ({
    type: 'SET_360_DATA',
    payload,
});
const setEPSData = (payload) => ({
    type: 'SET_EPS_DATA',
    payload,
});
const setSpecificCompanySignals = (payload) => ({
    type: 'SET_SPECIFIC_COMPANY_SIGNAL',
    payload,
});
const setImpactData = (payload) => ({
    type: 'SET_IMPACT_DATA',
    payload,
});
const setNetworkData = (payload) => ({
    type: 'SET_NETWORK_DATA',
    payload,
});
const setSignalMap = (payload) => ({
    type: 'SET_SIGNAL_MAP',
    payload,
});
const setCorrectId = (payload) => ({
    type: 'SET_CORRECT_ID',
    payload,
});
const resetStockConcensusData = (payload) => ({
    type: 'RESET_STOCK_DATA',
});
const resetShareRatioData = (payload) => ({
    type: 'RESET_SHARE_RATIO_DATA',
});
const resetFinancialData = (payload) => ({
    type: 'RESET_FINANCIAL_DATA',
});
const resetEpsData = (payload) => ({
    type: 'RESET_EPS_DATA',
});
const setCompanyAnalystData = (payload) => ({
    type: 'SET_COMPANY_ANALYST_DATA',
    payload,
});
const showChatBot = (payload) => ({
    type: 'SET_CHAT_BOT',
});
const showChatNotification = (payload) => ({
    type: 'SET_CHAT_NOTIFICATION',
    payload,
});
const checkAnalystStatus = (payload) => ({
    type: 'CHECK_ANALYST_STATUS',
    payload,
});

export const mutation = {
    setCompanySignals,
    setCompanySharePrice,
    setFinancialData,
    setCriticalFactors,
    setCorrectId,
    setStockConsensus,
    setShareRatio,
    set360Data,
    setEPSData,
    setSpecificCompanySignals,
    setImpactData,
    setNetworkData,
    setSignalMap,
    setCompanyList,
    resetEpsData,
    resetStockConcensusData,
    resetShareRatioData,
    resetFinancialData,
    setFilteredCriticalFactors,
    setCompanyAnalystData,
    setActiveRic,
    setActiveRicValue,
    showChatBot,
    checkAnalystStatus,
    showChatNotification,
};
